import * as Yup from 'yup';
import { useState, useContext } from 'react';
import { Icon } from '@iconify/react';
import { useFormik, Form, FormikProvider } from 'formik';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { useNavigate } from 'react-router-dom';
import { Stack, TextField, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material/styles';
import { register } from '../../api/auth';
import { UserContext } from '../../Contexts/UserContext';
import { getUserDataFromToken } from '../../api/auth';
import { toast } from 'react-toastify';

// Styled Components
const StyledLoadingButton = styled(LoadingButton)(({ theme }) => ({
	borderRadius: '8px'
}));
export default function RegisterForm() {
	const { setUser } = useContext(UserContext);
	const navigate = useNavigate();
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const RegisterSchema = Yup.object().shape({
		email: Yup.string().email('Email must be a valid email address').required('Email is required'),
		password: Yup.string().min(3).max(15).required('Password is required'),
		confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match')
	});

	const handleSignupFormSubmit = async (formData) => {
		try {
			console.log('formData is : ', formData);
			const userSignupData = await register(formData);
			console.log('User Data is : ', userSignupData);
			navigate(`/verify-code?email=${userSignupData?.data?.email}&forgotPassword=false`, {
				replace: true
			});
		} catch (err) {
			toast.error('Error Signing Up');
		}
	};

	const formik = useFormik({
		initialValues: {
			email: '',
			password: '',
			confirmPassword: ''
		},
		validationSchema: RegisterSchema,
		onSubmit: handleSignupFormSubmit
	});

	const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

	return (
		<FormikProvider value={formik}>
			<Form autoComplete="off" noValidate onSubmit={handleSubmit}>
				<Stack spacing={3}>
					<TextField
						fullWidth
						autoComplete="email"
						type="email"
						label="Email address"
						{...getFieldProps('email')}
						error={Boolean(touched.email && errors.email)}
						helperText={touched.email && errors.email}
					/>

					<TextField
						fullWidth
						type={showPassword ? 'text' : 'password'}
						label="Password"
						{...getFieldProps('password')}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
										<Icon icon={showPassword ? eyeFill : eyeOffFill} />
									</IconButton>
								</InputAdornment>
							)
						}}
						error={Boolean(touched.password && errors.password)}
						helperText={touched.password && errors.password}
					/>

					<TextField
						fullWidth
						type={showConfirmPassword ? 'text' : 'password'}
						label="Confirm Password"
						{...getFieldProps('confirmPassword')}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton edge="end" onClick={() => setShowConfirmPassword((prev) => !prev)}>
										<Icon icon={showConfirmPassword ? eyeFill : eyeOffFill} />
									</IconButton>
								</InputAdornment>
							)
						}}
						error={Boolean(touched.password && errors.password)}
						helperText={touched.password && errors.password}
					/>

					<StyledLoadingButton
						fullWidth
						size="large"
						type="submit"
						variant="contained"
						loading={isSubmitting}
					>
						Sign Up
					</StyledLoadingButton>
				</Stack>
			</Form>
		</FormikProvider>
	);
}
